export const addOrEditGroupTranslations = {
  en: {
    groupUpdatedSuccess: "Group updated successfully",
    groupCreatedSuccess: "Group created successfully",
    editGroup: "Edit Group",
    createNewGroup: "Create New Group",
    uploadGroupPhoto: "Upload group photo",
    removeImage: "Remove image",
    groupPreviewAlt: "Group preview",
    groupNameLabel: "Group Name",
    groupNamePlaceholder: "Enter group name",
    groupNameRequired: "Group name is required", 
    groupNameTooLong: "Group name must be 25 characters or less",
    groupDescriptionLabel: "Group Description",
    groupDescriptionPlaceholder: "Enter group description (optional)",
    groupBioTooLong: "Description must be 125 characters or less",
    addMembersLabel: "Add Members",
    searchMembersPlaceholder: "Search members...",
    loadingContacts: "Loading contacts...",
    errorLoadingContacts: "Failed to load contacts",
    noContactsFound: "No contacts found",
    noContactsAvailable: "No contacts available",
    invalidImageType: "Only JPG and PNG images are allowed",
    imageTooLarge: "Image size must be 1MB or less",
    memberCountSingular: "{count} member",
    memberCountPlural: "{count} members selected",
    cancel: "Cancel",
    updateGroup: "Update Group",
    createGroup: "Create Group",
    member: "member",
    member_plural: "members",
    selected: "selected",
  },
  de: {
    groupUpdatedSuccess: "Gruppe erfolgreich aktualisiert",
    groupCreatedSuccess: "Gruppe erfolgreich erstellt",
    member: "Mitglied",
    member_plural: "Mitglieder",
    selected: "ausgewählt",
    editGroup: "Gruppe bearbeiten",
    createNewGroup: "Neue Gruppe erstellen",
    uploadGroupPhoto: "Gruppenfoto hochladen",
    removeImage: "Bild entfernen",
    groupPreviewAlt: "Gruppenvorschau",
    groupNameLabel: "Gruppenname",
    groupNamePlaceholder: "Gruppenname eingeben",
    groupNameRequired: "Gruppenname ist erforderlich",
    groupNameTooLong: "Gruppenname darf höchstens 25 Zeichen lang sein",
    groupDescriptionLabel: "Gruppenbeschreibung",
    groupDescriptionPlaceholder: "Gruppenbeschreibung eingeben (optional)",
    groupBioTooLong: "Beschreibung darf höchstens 125 Zeichen lang sein",
    addMembersLabel: "Mitglieder hinzufügen",
    searchMembersPlaceholder: "Mitglieder suchen...",
    loadingContacts: "Kontakte werden geladen...",
    errorLoadingContacts: "Kontakte konnten nicht geladen werden",
    noContactsFound: "Keine Kontakte gefunden",
    invalidImageType: "Nur JPG- und PNG-Bilder sind erlaubt",
    imageTooLarge: "Bildgröße darf höchstens 1MB betragen",
    noContactsAvailable: "Keine Kontakte verfügbar",
    memberCountSingular: "{count} Mitglied",
    memberCountPlural: "{count} Mitglieder ausgewählt",
    cancel: "Abbrechen",
    updateGroup: "Gruppe aktualisieren",
    createGroup: "Gruppe erstellen",
  },
  hr: {
    member: "Mitglied",     
    member_plural: "Mitglieder",   
    selected: "ausgewählt",
    editGroup: "Uredi grupu",
    createNewGroup: "Stvori novu grupu",
    uploadGroupPhoto: "Učitaj grupnu fotografiju",
    removeImage: "Ukloni sliku",
    groupPreviewAlt: "Pregled grupe",
    groupNameLabel: "Naziv grupe",
    groupNamePlaceholder: "Unesite naziv grupe",
    groupNameRequired: "Naziv grupe je obvezan",
    groupNameTooLong: "Naziv grupe mora imati 25 znakova ili manje",
    groupDescriptionLabel: "Opis grupe",
    groupDescriptionPlaceholder: "Unesite opis grupe (opcionalno)",
    groupBioTooLong: "Opis mora imati 125 znakova ili manje",
    addMembersLabel: "Dodaj članove",
    searchMembersPlaceholder: "Pretraži članove...",
    loadingContacts: "Učitavanje kontakata...",
    noContactsFound: "Nema pronađenih kontakata",
    noContactsAvailable: "Nema dostupnih kontakata",
    errorLoadingContacts: "Kontakti se nisu mogli učitati",
    invalidImageType: "Dopuštene su samo JPG i PNG slike",
    imageTooLarge: "Veličina slike mora biti 1MB ili manje",
    memberCountSingular: "{count} član",
    memberCountPlural: "{count} članova odabrano",
    cancel: "Odustani",
    updateGroup: "Ažuriraj grupu",
    createGroup: "Stvori grupu",
    groupUpdatedSuccess: "Grupa je uspješno ažurirana",
    groupCreatedSuccess: "Grupa je uspješno kreirana",
  },
};
